module.exports = __webpack_public_path__ + "static/media/CC-Dragon_spearneck.d13446e2.png";